import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useEffect, useState } from "react";
import "./App.css";
import Loader from "./components/Loader";
import Mouse from "./components/Mouse";
import Header from "./components/Header/Header";
import Offcanvas from "./components/Offcanvas";
import Home from "./pages/Home/Home";
import BacktoTop from "./components/BacktoTop";
import Footer from "./components/Footer";

import { WOW } from "wowjs";
import "animate.css";

import Contact from "./pages/Contact/Contact";
import About from "./pages/About/About";
import Blog from "./pages/Blog/Blog";
import Top from "./components/Top";
import NotFound from "./components/NotFound";
import BlogDetails from "./pages/BlogDetails/BlogDetails";
import BusinessPortfolio from "./pages/BusinessPortfolio/BusinessPortfolio";
import Gallery from "./pages/Gallery/Gallery";
import CSR from "./pages/CSR/CSR";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  // WOW Animation
  useEffect(() => {
    const wow = new WOW({
      boxClass: "wow",
      animateClass: "animate__animated",
      offset: 0,
      mobile: true,
      live: true,
    });
    wow.init();
  }, []);

  // Loader
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <BrowserRouter>
      <Top />
      <Mouse />
      <Header toggleMenu={toggleMenu} />
      <Offcanvas closeMenu={closeMenu} menuOpen={menuOpen} />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/business-portfolio" element={<BusinessPortfolio />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/csr" element={<CSR />} />
          <Route path="/news-media" element={<Blog />} />
          <Route path="/news-media-details" element={<BlogDetails />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <Footer />
      <BacktoTop />
    </BrowserRouter>
  );
}

export default App;
